import React from 'react'
import Nav from '../Component/Nav/Nav'
import Banner2 from '../Component/Banner/Banner2'
import Workstogether from '../Component/Worktogether/Workstogether'
import Footer from '../Component/Footer/Footer'

export default function Contact() {
  return (
    <>
      <Nav/>
      <Banner2 bannerName="In Touch"/>
      <Workstogether/>
      <Footer/>
    </>
    )
}

